export default __webpack_public_path__ + "deepseekeb864f.png";